<template lang="pug">
  .notification
    .notification__header
      .notification__title Оплаченный период закончится
        span(v-if="payload.daysRemain <= 1") завтра
        span(v-else) через {{ payload.daysRemain }} дня
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        span(v-if="payload.daysRemain <= 1")
          | Оплаченный период заканчивается через
          strong 24 часа.
        span(v-else)
          | Оплаченный период закончится через
          strong {{ payload.daysRemain }} дня.
        | Оплатите заранее, чтобы обеспечить бесперебойность работы.
        br
        router-link.notification__link(
          @click.native="emitClick"
          title="Перейти к оплате"
          :to="{name: 'payments'}"
        ) Перейти к оплате
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'PackageEndsSoon',
  mixins: [notification]
};
</script>
